import React from "react";
import DOMPurify from "dompurify";

const isHtml = (s) => /<\/?[a-z][\s\S]*>/i.test(s || "");
const escape = (s) => s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

export const toHtml = (s) => {
  if (!s) return "";
  if (isHtml(s)) return s;
  return s.split(/\n{2,}/).map((p) => `<p>${escape(p).replace(/\n/g, "<br>")}</p>`).join("");
};

export const toPlainText = (s) => {
  if (!isHtml(s)) return s || "";
  const div = document.createElement("div");
  div.innerHTML = DOMPurify.sanitize(s.replace(/<\/(p|h2|h3|li)>/g, "</$1> "));
  return div.textContent.replace(/\s+/g, " ").trim();
};

export function RichText({ html, className = "", testId }) {
  if (!html) return null;
  return (
    <div data-testid={testId} className={`rich-text ${className}`}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(toHtml(html), { ADD_ATTR: ["target"] }) }} />
  );
}
